// Vue
import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import { AppModule } from './modules/app';
import { CustomersModule } from './modules/customer';
import { DailyYardVehicleModule } from './modules/dailyYardVehicle';
import { DriversModule } from './modules/driver';
import { DriversLeaveModule } from './modules/driverLeave';
import { DriverPaymentsModule } from './modules/driverPayment';
import { EmailAddressModule } from './modules/emailAddress';
import { JobCardsModule } from './modules/jobCard';
import { LoadsModule } from './modules/load';
import { AdhocMaintenanceModule } from './modules/adhocMaintenance';
import { ReportsModule } from './modules/report';
import { RoutesModule } from './modules/route';
import { TermModule } from './modules/term';
import { UserModule } from './modules/user';
import { VehiclesModule } from './modules/vehicle';

Vue.use(Vuex);

const store = new Vuex.Store<any>({
  modules: {
    app: AppModule,
    customers: CustomersModule,
    dailyYardVehicles: DailyYardVehicleModule,
    drivers: DriversModule,
    driversLeave: DriversLeaveModule,
    driverPayments: DriverPaymentsModule,
    emailAddresses: EmailAddressModule,
    jobCards: JobCardsModule,
    loads: LoadsModule,
    adhocMaintenance: AdhocMaintenanceModule,
    reports: ReportsModule,
    routes: RoutesModule,
    terms: TermModule,
    users: UserModule,
    vehicles: VehiclesModule,
  },
});

export default store;
